// UX-2026-05-27: English dictionary (second language).
// 缺失 key 会 fallback 到中文 (default locale).

import type { Dict } from "./zh-CN";

export const enUS: Dict = {
  "nav.rooms": "Rooms",
  "nav.login": "Sign in",
  "nav.settings": "Settings",
  "nav.help": "Help",
  "nav.about": "About",
  "nav.logout": "Sign out",
  "nav.brand.title": "Back to ChatBox website",

  "action.confirm": "OK",
  "action.cancel": "Cancel",
  "action.save": "Save",
  "action.delete": "Delete",
  "action.edit": "Edit",
  "action.close": "Close",
  "action.back": "Back",
  "action.next": "Next",
  "action.copy": "Copy",
  "action.download": "Download",

  "room.list.title": "Conversations",
  "room.list.new": "New conversation",
  "room.list.empty": "No conversations yet",
  "room.list.empty.cta": "Start your first conversation",
  "room.create.title": "New conversation",
  "room.create.label": "Conversation name",
  "room.create.placeholder": "e.g. Pair with AI",
  "room.create.confirm": "Create",
  "room.menu.rename": "Rename",
  "room.menu.rename.title": "Rename conversation",
  "room.menu.rename.label": "New name",
  "room.menu.rename.confirm": "Save",
  "room.menu.clear": "Clear history",
  "room.menu.clear.confirm": "Clear all messages in “{name}”? The room itself stays.",
  "room.menu.clear.btn": "Clear",
  "room.menu.delete": "Delete",
  "room.menu.delete.confirm": "Delete “{name}”? Room and all history will be erased and cannot be recovered.",
  "room.menu.delete.btn": "Delete",

  "members.title": "Members",
  "members.self": "Current account",
  "members.online": "Online",
  "members.anon": "Anonymous",
  "members.agent.sub": "AI terminal",
  "members.tip.self": "Current account",
  "members.tip.agent": "Open @{name} terminal session",
  "members.tip.peer": "Chat with {name} privately",

  "composer.placeholder": "Say something… (type @ to summon an agent · Enter to send)",
  "composer.placeholder.connecting": "Connecting…",
  "composer.tool.stt": "Speech to text",
  "composer.tool.stt.recording": "Transcribing",
  "composer.tool.voice": "Record voice",
  "composer.tool.voice.recording": "Stop",
  "composer.tool.attachment": "Image / HTML",
  "composer.send": "Send",

  "empty.pick": "Pick a conversation to start",
  "empty.signin": "Verifying your identity…",
  "empty.signinRequired": "Please sign in first.",

  "settings.account.title": "Account",
  "settings.account.nickname": "Display name",
  "settings.account.username": "Username",
  "settings.account.email": "Email",
  "settings.account.avatar": "Change avatar",
  "settings.password.title": "Password",
  "settings.password.placeholder1": "New password (≥ 8 chars)",
  "settings.password.placeholder2": "Confirm new password",
  "settings.password.update": "Update password",
  "settings.password.saving": "Saving…",
  "settings.password.set": "(set)",
  "settings.account.nick.placeholder": "2-32 characters",
  "settings.account.nick.unset": "Unnamed",
  "settings.account.nick.empty": "(not set)",
  "settings.account.uname.placeholder": "6-20 chars · start with letter",
  "settings.account.uname.checking": "Checking…",
  "settings.account.uname.ok": "✓ Available",
  "settings.account.uname.hint": "Start with letter, 6-20 chars · letters/digits/_/- only · unique site-wide",
  "settings.account.uname.unset": "not set",
  "common.save": "Save",
  "common.saving": "Saving…",
  "common.edit": "Edit",
  "common.cancel": "Cancel",
  "settings.ai.title": "AI Adapters (Agent Host)",
  "settings.security.devices.unnamed": "(unnamed device)",
  "settings.security.devices.revoked": "Revoked",
  "settings.display.sound.custom.uploaded": "Uploaded (stored locally, not uploaded)",
  "settings.about.localData.subtitle": "Local data",
  "settings.account.avatar.upload": "Upload avatar",
  "settings.account.avatar.remove": "Remove",
  "settings.password.modify": "Change",
  "settings.display.lang.title": "Language",
  "settings.display.lang.sub": "Applied immediately. Stored locally per device.",
  "settings.display.sound.title": "Notification sound",
  "settings.display.sound.custom": "Custom",
  "settings.security.devices.title": "This device's signing key",
  "settings.security.devices.loading": "Loading…",
  "settings.security.devices.empty": "No device keys registered yet (sign in again to auto-register).",
  "settings.about.title": "About",
  "settings.about.version": "Version",
  "settings.about.checkUpdate": "Check for updates",
  "settings.about.checkingUpdate": "Checking…",
  "settings.about.localData": "Local data",
  "settings.about.localData.sub": "Message history / conversations / preferences live on this device. Export to JSON; re-import on a new device.",
  "settings.about.localData.warn": "⚠ Import overwrites all current data. Export first.",
  "settings.about.export": "Export data",
  "settings.about.import": "Import backup",
  "settings.about.helpDocs": "Help docs",
  "settings.about.feedback": "Send feedback",

  "adapter.configured.head": "{count} AI configured",
  "adapter.rooms.title": "Which conversations should these AIs join?",
  "adapter.rooms.sub": "Save the config, agent-host will reconnect to the selected rooms.",
  "adapter.rooms.empty": "No rooms yet. Click + on the left to create one.",
  "adapter.advanced.summary": "Advanced · View raw toml / change device_id",
  "adapter.bootlog.summary": "Boot log · ~/.chatbox/agent-host-boot.log",
  "adapter.bootlog.empty": "(No boot log yet, start agent-host once first.)",
  "adapter.intro.head": "Pick a template + fill the form →",
  "adapter.intro.desktop": "Desktop saves the config and manages local Agent Host directly.",
  "adapter.intro.web": "Web lets you copy or download the config file.",
  "adapter.sub.desktop": "Adding / removing auto-saves and restarts Agent Host",
  "adapter.sub.web": "Multiple at once: Claude Code, Codex, API, Ollama...",
  "adapter.list.remove": "Remove",
  "adapter.template.add.tip": "↑ Click to add more. After saving they appear in room members and the @ menu",
  "adapter.form.cancel": "Cancel",
  "adapter.form.preInstall": "Pre-install:",
  "adapter.form.preview": "Live TOML preview",
  "adapter.form.add.apply": "Add and apply",
  "adapter.form.add": "Add",
  "adapter.rooms.sub.full": "After saving, agent-host will reconnect to these rooms. After creating new rooms, come back and check them.",
  "adapter.rooms.empty.cta": "No rooms yet. Click + on the left to create one.",
  "adapter.web.copy": "Copy",
  "adapter.web.download": "Download agent-host.toml",
  "adapter.web.runHint.line1": "Save to",
  "adapter.web.runHint.line2": "then:",
  "adapter.quota.summary": "Guest quotas ({n})",
  "adapter.quota.summary.sub": "Per user_id daily/monthly limits, exceeded = deny",
  "adapter.quota.empty": "No quota rules · empty = unlimited. user_id can be \"*\" wildcard; exact match takes priority.",
  "adapter.quota.col.user": "user_id or *",
  "adapter.quota.col.dailyTok": "daily token",
  "adapter.quota.col.dailyUsd": "daily USD",
  "adapter.quota.col.monthlyTok": "monthly token",
  "adapter.quota.col.totalUsd": "total USD",
  "adapter.quota.row.remove": "Remove row",
  "adapter.quota.row.add": "+ Add rule",
  "adapter.quota.foot": "Click \"Save & Restart\" above to apply. Empty = no limit. quota=0 not supported (=no limit). To fully disable a user, delete the rule.",
  "agentHost.running": "Agent Host running",
  "agentHost.idle": "Agent Host stopped",
  "agentHost.notFound": "sidecar not found",
  "agentHost.paths.config": "Config:",
  "agentHost.paths.exe": "Binary:",
  "agentHost.btn.restart": "Save & restart",
  "agentHost.btn.doctor": "Validate",
  "agentHost.btn.save": "Save only",
  "agentHost.btn.start": "Start",
  "agentHost.btn.stop": "Stop",
  "agentHost.btn.refresh": "Refresh",
  "agentHost.doctor.ok": "doctor passed",
  "agentHost.doctor.bad": "doctor output",
  "bootlog.btn.refresh": "Refresh",
  "bootlog.btn.refreshing": "Reading…",
  "bootlog.btn.copy": "Copy",
  "bootlog.btn.clear": "Clear",
  "bootlog.content.empty": "(empty)",
  "bootlog.content.cleared": "(cleared)",

  "approval.signing": "Signing…",
  "approval.error": "Error: {msg}",
  "approval.title": "wants to run this command, please approve",
  "approval.meta.invocation": "invocation",
  "approval.meta.hash": "hash",
  "approval.warn.notMine": "This approval belongs to {user}, not you — you cannot sign on their behalf.",
  "approval.btn.approve": "Approve and run",
  "approval.btn.deny": "Deny",
  "approval.sent": "Signed and sent, waiting for agent",
  "approval.expired": "Request expired",

  "invite.title": "Invite to #{room}",
  "invite.close": "Close",
  "invite.field.uses": "Uses",
  "invite.field.ttl": "Valid for",
  "invite.field.note": "Note",
  "invite.uses.1": "1 use",
  "invite.uses.5": "5 uses",
  "invite.uses.unlimited": "Unlimited",
  "invite.ttl.1d": "1 day",
  "invite.ttl.7d": "7 days",
  "invite.ttl.30d": "30 days",
  "invite.note.placeholder": "Private to you, can be empty",
  "invite.create": "Generate invite link",
  "invite.creating": "Generating…",
  "invite.created.unlimited": "Link generated (unlimited)",
  "invite.created.quota": "Link generated ({n} slots)",
  "invite.copy": "Copy",
  "invite.created.expires": "Share the link with them. Expires in {days} days.",
  "invite.create.again": "Generate another",
  "invite.error": "Error: {msg}",
  "invite.retry": "Retry",
  "invite.my": "My invites ({n})",
  "invite.used.head": "{used}/{cap} used",
  "invite.used.unlimited": "{used}/∞ used",
  "invite.remain.days": "{n} d remaining",
  "invite.revoked": "Revoked",
  "invite.see.who": "Who joined ({n})",
  "invite.fold.who": "Hide who joined",
  "invite.revoke": "Revoke",
  "invite.redemptions.loading": "Loading…",
  "invite.redemptions.empty": "No records yet",
  "invite.revoke.confirm": "Revoking immediately invalidates the link. People already joined are unaffected. Continue?",
  "invite.revoke.failed": "Revoke failed: {msg}",
  "invite.copy.fallback": "Copy this link:",
  "invite.load.failed": "Load failed",

  "settings.tab.account": "Account",
  "settings.tab.security": "Security",
  "settings.tab.ai": "AI Adapters",
  "settings.tab.display": "Display & Notifications",
  "settings.tab.about": "About",

  "about.version": "Version",
  "about.build": "Build time",
  "about.commit": "Commit",
  "about.checkUpdate": "Check for updates",
  "about.help": "Help docs",
  "about.feedback": "Send feedback",
  "about.license": "License",

  "updater.title.found": "New version {version} available",
  "updater.title.forced": "⚠ Update to {version} required",
  "updater.sub.current": "Current {version}",
  "updater.body.normal": "A new version is ready. It only takes a few seconds to update.",
  "updater.body.forced": "This is a critical update with security or compatibility fixes. You must update to continue using ChatBox.",
  "updater.notes.show": "Show release notes",
  "updater.notes.hide": "Hide release notes",
  "updater.btn.now": "Update now",
  "updater.btn.later": "Later",
  "updater.btn.exit": "Quit app",
  "updater.btn.installing": "Updating...",
  "updater.progress.prepare": "Preparing download...",
  "updater.progress.finished": "Installed, restarting...",
};
